import { EventEmitter } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { DEFAULT_LAG, DEFAULT_WEIGHT, MAX_LAG, MAX_LOOKBACK_WINDOW, MAX_WEIGHT, MIN_LAG, MIN_LOOKBACK_WINDOW, MIN_WEIGHT, } from 'ChartApp/ts/features/fund-chart-page-shared/components/chart-correlation-selector-modal/constants';
import { INDICATOR } from 'NewAngular/constants/core.constants';
import { CorrelationType } from 'ChartApp/ts/enums/fund-chart-common.enum';
import { CorrelationSecurityType } from 'ChartApp/ts/interfaces/fund-chart.interface';
import { isSecurityType } from 'NewAngular/utils/security-utils';
import * as i0 from "@angular/core";
function ChartCorrelationSelectorModalComponent_div_8_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.lookbackWindowErrorMessage, " ");
} }
function ChartCorrelationSelectorModalComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "label", 13);
    i0.ɵɵtext(3, "Number of ");
    i0.ɵɵelement(4, "br");
    i0.ɵɵtext(5, "Lookback Periods");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14)(7, "input", 15);
    i0.ɵɵtwoWayListener("ngModelChange", function ChartCorrelationSelectorModalComponent_div_8_Template_input_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.correlationData.lookbackWindow, $event) || (ctx_r1.correlationData.lookbackWindow = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ChartCorrelationSelectorModalComponent_div_8_div_8_Template, 2, 1, "div", 16);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.correlationData.lookbackWindow);
    i0.ɵɵproperty("min", ctx_r1.minLookbackWindow)("max", ctx_r1.maxLookbackWindow);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.correlationErrors.invalidLookbackWindow);
} }
function ChartCorrelationSelectorModalComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.unfilledErrorMessage, " ");
} }
export class ChartCorrelationSelectorModalComponent {
    constructor() {
        this.defaultOnly = false;
        this.handler = new EventEmitter();
        this.isOpen = false;
        this.correlationTypeOptions = [CorrelationType.RATIO, CorrelationType.SPREAD, CorrelationType.CORRELATION];
        this.correlationData = {};
        this.correlationErrors = {
            securityA: {
                lag: false,
                weight: false,
            },
            securityB: {
                lag: false,
                weight: false,
            },
            unfilled: false,
            invalidLookbackWindow: false,
        };
        this.unfilledErrorMessage = 'Error: Please fill out all fields before submitting.';
        this.minLookbackWindow = MIN_LOOKBACK_WINDOW;
        this.maxLookbackWindow = MAX_LOOKBACK_WINDOW;
        this.lookbackWindowErrorMessage = `Value should be a positive number between ${MIN_LOOKBACK_WINDOW} and ${MAX_LOOKBACK_WINDOW}`;
    }
    reset() {
        this.correlationData = { correlationType: CorrelationType.RATIO };
        if (this.maxCorrelationId) {
            this.correlationData.correlationId = this.maxCorrelationId + 1;
        }
        this.correlationData.lookbackWindow = undefined;
        this.correlationData.securityA = {
            securityType: CorrelationSecurityType.FIXED,
            security: '',
            metric: '',
            lag: DEFAULT_LAG,
            weight: DEFAULT_WEIGHT,
        };
        this.correlationData.securityB = {
            securityType: CorrelationSecurityType.FIXED,
            security: '',
            metric: '',
            lag: DEFAULT_LAG,
            weight: DEFAULT_WEIGHT,
        };
        this.correlationErrors = {
            securityA: {
                lag: false,
                weight: false,
            },
            securityB: {
                lag: false,
                weight: false,
            },
            unfilled: false,
            invalidLookbackWindow: false,
        };
    }
    populate(correlationData) {
        const { correlationId, correlationType, lookbackWindow, lagA, lagB, weightA, weightB, securityA, metricA, securityB, metricB, } = correlationData;
        this.correlationData.correlationId = correlationId;
        if ([CorrelationType.RATIO, CorrelationType.SPREAD, CorrelationType.CORRELATION].includes(correlationType)) {
            this.correlationData.correlationType = correlationType;
        }
        if (lookbackWindow && this.isLookbackWindowValid(lookbackWindow)) {
            this.correlationData.lookbackWindow = lookbackWindow;
        }
        if (lagA && this.isLagValid(lagA)) {
            this.correlationData.securityA.lag = lagA;
        }
        if (lagB && this.isLagValid(lagB)) {
            this.correlationData.securityB.lag = lagB;
        }
        if (weightA && this.isWeightValid(weightA)) {
            this.correlationData.securityA.weight = weightA;
        }
        if (weightB && this.isWeightValid(weightB)) {
            this.correlationData.securityB.weight = weightB;
        }
        this.correlationData.securityA.security = { id: securityA };
        this.correlationData.securityA.metric = metricA || '';
        this.correlationData.securityB.security = { id: securityB };
        this.correlationData.securityB.metric = metricB || '';
    }
    openModal(selectedCorrelationData, index) {
        this.reset();
        this.selectedCorrelationIndex = index;
        if (selectedCorrelationData) {
            this.selectedCorrelationId = selectedCorrelationData.correlationId;
            this.populate(selectedCorrelationData);
        }
        this.isOpen = true;
    }
    closeModal() {
        this.isOpen = false;
        this.reset();
    }
    submit() {
        const { securityA } = this.correlationData;
        const securityAMetric = securityA.metric;
        const securityAMetricId = securityAMetric?.id;
        // external representation of correlation data
        const securityASecurity = securityA.security;
        // Submit '' for indicator metrics
        const metricA = securityASecurity?.id && isSecurityType(INDICATOR, securityASecurity.id) ? '' : securityAMetricId;
        const { securityB } = this.correlationData;
        const securityBMetric = securityB.metric;
        const securityBMetricId = securityBMetric?.id;
        // external representation of correlation data
        const securityBSecurity = securityB.security;
        // Submit '' for indicator metrics
        const metricB = securityBSecurity.id && isSecurityType(INDICATOR, securityBSecurity.id) ? '' : securityBMetricId;
        let correlation = {
            correlationId: this.correlationData.correlationId,
            correlationType: this.correlationData.correlationType,
            include: true,
            lagA: securityA.lag,
            lagB: securityB.lag,
            metricA,
            metricB,
            securityA: securityASecurity.id ?? '',
            securityAType: securityASecurity.securityType,
            securityB: securityBSecurity.id ?? '',
            securityBType: securityBSecurity.securityType,
            weightA: securityA.weight,
            weightB: securityB.weight,
        };
        if (correlation.correlationType === CorrelationType.CORRELATION && this.correlationData.lookbackWindow) {
            correlation = {
                ...correlation,
                lookbackWindow: this.correlationData.lookbackWindow,
            };
        }
        const valid = this.validateFields(correlation);
        if (valid) {
            this.handler.emit({
                correlation: {
                    ...correlation,
                    correlationId: correlation.correlationId ?? this.selectedCorrelationIndex,
                },
                correlationIndex: this.selectedCorrelationIndex,
            });
            this.closeModal();
        }
        this.correlationErrors = cloneDeep(this.correlationErrors);
    }
    validateFields(correlationObj) {
        // Performs validation against the correlationData (except for security-metric valid pairing which
        // should be done in metricIdSelect and onSecurityIdSelect)
        // All unfilled validations are performed here
        const { metricA, securityA, metricB, securityB, correlationType, weightA, weightB, lagA, lagB, lookbackWindow, } = correlationObj;
        if ((metricA === undefined || !securityA) && !isSecurityType(INDICATOR, securityA)) {
            this.correlationErrors.unfilled = true;
            return false;
        }
        if ((metricB === undefined || !securityB) && !isSecurityType(INDICATOR, securityB)) {
            this.correlationErrors.unfilled = true;
            return false;
        }
        if (metricA === undefined || metricB === undefined || !securityA || !securityB) {
            this.correlationErrors.unfilled = true;
        }
        switch (correlationType) {
            case CorrelationType.SPREAD:
                if (weightA === undefined || weightB === undefined) {
                    this.correlationErrors.unfilled = true;
                    return false;
                }
                this.correlationErrors.unfilled = false;
                return this.validateWeight(correlationObj);
            case CorrelationType.CORRELATION:
                if (lagA === undefined || lagB === undefined) {
                    this.correlationErrors.unfilled = true;
                    return false;
                }
                this.correlationErrors.unfilled = false;
                if (lookbackWindow !== undefined && !this.isLookbackWindowValid(lookbackWindow)) {
                    this.correlationErrors.invalidLookbackWindow = true;
                    return false;
                }
                this.correlationErrors.invalidLookbackWindow = false;
                return this.validateLag(correlationObj);
            default:
                break;
        }
        this.correlationErrors.unfilled = false;
        return true;
    }
    validateLag(correlationObj) {
        let valid = true;
        if (correlationObj.lagA !== undefined && !this.isLagValid(correlationObj.lagA)) {
            this.correlationErrors.securityA.lag = true;
            valid = false;
        }
        else {
            this.correlationErrors.securityA.lag = false;
        }
        if (correlationObj.lagB !== undefined && !this.isLagValid(correlationObj.lagB)) {
            this.correlationErrors.securityB.lag = true;
            valid = false;
        }
        else {
            this.correlationErrors.securityB.lag = false;
        }
        return valid;
    }
    validateWeight(correlationObj) {
        let valid = true;
        if (correlationObj.weightA !== undefined && !this.isWeightValid(correlationObj.weightA)) {
            this.correlationErrors.securityA.weight = true;
            valid = false;
        }
        else {
            this.correlationErrors.securityA.weight = false;
        }
        if (correlationObj.weightB !== undefined && !this.isWeightValid(correlationObj.weightB)) {
            this.correlationErrors.securityB.weight = true;
            valid = false;
        }
        else {
            this.correlationErrors.securityB.weight = false;
        }
        return valid;
    }
    isLagValid(lag) {
        return this.isNumber(lag, true) && lag >= MIN_LAG && lag <= MAX_LAG;
    }
    isWeightValid(weight) {
        return this.isNumber(weight) && !!weight && weight >= MIN_WEIGHT && weight <= MAX_WEIGHT;
    }
    isLookbackWindowValid(lookbackWindow) {
        return Boolean(lookbackWindow &&
            this.isNumber(lookbackWindow, true) &&
            lookbackWindow >= MIN_LOOKBACK_WINDOW &&
            lookbackWindow <= MAX_LOOKBACK_WINDOW);
    }
    isNumber(n, integerCheck) {
        if (integerCheck) {
            return !Number.isNaN(n) && Number.isFinite(n) && n % 1 === 0;
        }
        return !Number.isNaN(n) && Number.isFinite(n);
    }
    selectCorrelationType(type) {
        this.correlationData.correlationType = type;
    }
    correlationErrsChangeHandler({ securityErrors, securityOption }) {
        this.correlationErrors[securityOption] = cloneDeep(securityErrors);
    }
    correlationDataChangeHandler({ securityObj, securityOption, }) {
        const correlationDataSecurity = this.correlationData[securityOption];
        Object.keys(correlationDataSecurity).forEach((key) => {
            const _key = key;
            if (correlationDataSecurity[_key] !== securityObj[_key]) {
                correlationDataSecurity[_key] = securityObj[_key];
            }
        });
    }
}
ChartCorrelationSelectorModalComponent.ɵfac = function ChartCorrelationSelectorModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartCorrelationSelectorModalComponent)(); };
ChartCorrelationSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChartCorrelationSelectorModalComponent, selectors: [["ycn-chart-correlation-selector-modal"]], inputs: { maxCorrelationId: "maxCorrelationId", defaultOnly: "defaultOnly" }, outputs: { handler: "handler" }, standalone: false, decls: 11, vars: 13, consts: [["extraModalClasses", "modal-no-border", 3, "closeModalHandler", "open"], ["header", "Create a Ratio / Spread / Correlation", "resetModalText", "Reset", 3, "closeModalHandler", "resetModalHandler"], [1, "modal-body"], [3, "selectCorrelationType", "currentCorrelationType", "correlationTypeOptions"], [1, "tab-content"], [1, "tab-pane", "active"], ["label", "Security A", "securityOption", "securityA", 1, "modal-section", 3, "correlationDataChangeHandler", "securityErrorsHandler", "correlationType", "securityErrors", "securityObj", "defaultOnly"], ["label", "Security B", "securityOption", "securityB", 1, "modal-section", 3, "correlationDataChangeHandler", "securityErrorsHandler", "correlationType", "securityErrors", "securityObj", "defaultOnly"], ["class", "modal-section", 4, "ngIf"], ["class", "tab-pane active feedback feedback-invalid", 4, "ngIf"], [3, "cancelHandler", "submitHandler"], [1, "modal-section"], [1, "row", "form-row"], [1, "col", "modal-sidebar", "form-label", "col-form-label"], [1, "col-3"], ["data-test-id", "lookback-window", "type", "number", 1, "form-control", 3, "ngModelChange", "ngModel", "min", "max"], ["class", "feedback feedback-invalid", 4, "ngIf"], [1, "feedback", "feedback-invalid"], [1, "tab-pane", "active", "feedback", "feedback-invalid"]], template: function ChartCorrelationSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); })("resetModalHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { return ctx.reset(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "ycn-correlation-type-tabs", 3);
        i0.ɵɵlistener("selectCorrelationType", function ChartCorrelationSelectorModalComponent_Template_ycn_correlation_type_tabs_selectCorrelationType_3_listener($event) { return ctx.selectCorrelationType($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5)(6, "ycn-correlation-security-selector", 6);
        i0.ɵɵlistener("correlationDataChangeHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_correlation_security_selector_correlationDataChangeHandler_6_listener($event) { return ctx.correlationDataChangeHandler($event); })("securityErrorsHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_correlation_security_selector_securityErrorsHandler_6_listener($event) { return ctx.correlationErrsChangeHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "ycn-correlation-security-selector", 7);
        i0.ɵɵlistener("correlationDataChangeHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_correlation_security_selector_correlationDataChangeHandler_7_listener($event) { return ctx.correlationDataChangeHandler($event); })("securityErrorsHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_correlation_security_selector_securityErrorsHandler_7_listener($event) { return ctx.correlationErrsChangeHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, ChartCorrelationSelectorModalComponent_div_8_Template, 9, 4, "div", 8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(9, ChartCorrelationSelectorModalComponent_div_9_Template, 2, 1, "div", 9);
        i0.ɵɵelementStart(10, "ycn-simple-modal-footer", 10);
        i0.ɵɵlistener("cancelHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_simple_modal_footer_cancelHandler_10_listener() { return ctx.closeModal(); })("submitHandler", function ChartCorrelationSelectorModalComponent_Template_ycn_simple_modal_footer_submitHandler_10_listener() { return ctx.submit(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("currentCorrelationType", ctx.correlationData.correlationType)("correlationTypeOptions", ctx.correlationTypeOptions);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("correlationType", ctx.correlationData.correlationType)("securityErrors", ctx.correlationErrors.securityA)("securityObj", ctx.correlationData.securityA)("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("correlationType", ctx.correlationData.correlationType)("securityErrors", ctx.correlationErrors.securityB)("securityObj", ctx.correlationData.securityB)("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.correlationData.correlationType === "correlation");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.correlationErrors.unfilled);
    } }, encapsulation: 2 });
